import { z } from "zod";

export const holidaySchema = z.object({
  name: z.string().min(1, "Holiday Name is required"),
  startDate: z.string().min(1, "Start Date is required"),
  endDate: z.string().min(1, "End Date is required"),
  orderCalendarSetIds: z.array(z.string()).optional().default([]),
  workOrderCalendarSetIds: z.array(z.string()).optional().default([]),
});

export type HolidayFormData = z.infer<typeof holidaySchema>;
